import type { VNode } from "vue";
import { createVNode, render } from "vue";
import ZhMessageBox from "@/components/zhMessageBox/index.vue";
import type { IOptions, Option } from "@/components/zhMessageBox/type";

const getDivElement = () => {
    return document.createElement("div");
};
const vmMap = new Map();
// const instance: { resolve: (res: any) => void; reject: (reason?: any) => void } = {};

export let currentContainer = undefined as any;

const setComponentToBody = (option: IOptions) => {
    const container = (currentContainer = getDivElement());
    const vm: VNode = createVNode(ZhMessageBox, option);
    option.onVanish = () => {
        render(null, container);
    };

    option.onAction = (type: string) => {
        const { resolve, reject } = vmMap.get(vm);
        vmMap.delete(vm);
        if (type === "submit") {
            resolve(true);
        } else {
            reject("cancel");
        }
    };

    const appendTo: HTMLElement = document.body;

    render(vm, container);
    appendTo.appendChild(container.firstElementChild);
    return vm;
};

const zhMessageBox = (option: Option) => {
    if (typeof option === "string") {
        option = {
            title: option
        };
    }

    return new Promise((resolve, reject) => {
        const vm = setComponentToBody(option);
        vmMap.set(vm, { resolve, reject });
    });
};

export default zhMessageBox;

export const zhRejectBox = async (options: { tip: string; callBack: (params: any) => void }) => {
    const res = await zhMessageBox({
        title: "是否驳回",
        placeholder: "请输入驳回理由(必填)",
        tip: options.tip,
        callBack: options.callBack
    });
    if (res) {
        ElMessage.success("已驳回");
    }
    return res;
};
